import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";
import * as types from "@/app/types";

export default class APIMe extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postUploadPhoto = async ({
    ...body
  }: types.BodyUploadPhotoUsersMeUploadPhotoPost): Promise<object> => {
    let res = await this._fetch({
      url: `/users/me/upload-photo/`,
      method: "POST",
      body: body,
      bodyMime: "multipart/form-data",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
